const CloudServices = () => {
    return ( 
        <div className="dark:text-white py-6">
            Cloud services page
        </div>
     );
}
 
export default CloudServices;

